import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=e599cdfe"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=e599cdfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports